import { ApiResourceBaseClass as o } from "./baseApiCalls.js";
const s = "audio";
class r extends o {
  /**
   * Uploads an audio file using the media service.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api/v2/audio`
   */
  uploadAudio = async (t) => {
    const { data: a } = await this.post(`${s}`, t, {
      "Content-Type": "multipart/form-data"
    });
    return a;
  };
}
export {
  r as Audio
};
